import { createStyles } from '@material-ui/core/styles';

export default createStyles({
    totalContainer: {
        display: 'flex',
        padding: '10px 75px',
        justifyContent: 'space-between',
    }
});
